import _ from "lodash";
import Grid from "@mui/material/Grid";
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/system";
import { Typography, IconButton } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@mui/material/Button";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { unicodeToString } from "../../../../Js/Common";
import { CheckActions } from "../../../../Js/ILTActions";

const pathToParentMenu = ["root"];

const WwILTButton = (props) => {
  const classes = useStyles();
  const btn = useRef();
  let [classnames, setClassnames] = useState("");
  let [alignClass, setAlignClass] = useState("");
  let [buttonText, setButtonText] = useState(null);
  let [buttonActions, setButtonActions] = useState(null);
  let buttonData = useSelector((state) => state.currentILTActions.actionsData);
  //let [classnames, setClassnames] = useState('');

  useEffect(() => {
    if (
      props.data.style.decoration_classes !== null &&
      props.data.style.decoration_classes !== undefined
    ) {
      setClassnames(props.data.style.decoration_classes.join(" "));
    }

    if (
      props.data.style.fontSize !== null &&
      props.data.style.fontSize !== undefined
    ) {
      let classes = classnames + " " + props.data.style.fontSize;
      setClassnames(classes);
    }

    //setClassnames(classnames + " slideInLeft q-pa-xs");

    if (
      props.data.style.align !== null &&
      props.data.style.align !== undefined
    ) {
      setAlignClass(props.data.style.align);
    } else {
      setAlignClass("");
    }

    if (
      btn &&
      btn.current &&
      btn.current.style &&
      (buttonText == null ||
        (buttonText &&
          (buttonText.toLowerCase() == "play" ||
            buttonText.toLowerCase() == "play1" ||
            buttonText.toLowerCase() == "play2" ||
            buttonText.toLowerCase() == "info" ||
            buttonText.toLowerCase() == "close"))) &&
      props.data
    ) {
      console.log("!!!!", btn);
      //btn.current.style.backgroundColor = props.data.style.background.color;
      if (props.data.style.background.image) {
        btn.current.style.backgroundImage = `url(${sessionStorage.getItem(
          "media_url"
        )}image/${props.data.style.background.image})`;
      }
      btn.current.style.backgroundSize =
        buttonText &&
        (buttonText.toLowerCase() == "play" ||
          buttonText.toLowerCase() == "info" ||
          buttonText.toLowerCase() == "close")
          ? "30px"
          : buttonText && buttonText.toLowerCase() == "play1"
          ? "24px"
          : "18px";
      btn.current.style.backgroundRepeat = "no-repeat";
      btn.current.style.backgroundPosition = "center";
      btn.current.style.border = props.data.style.borderColor;
      btn.current.style.borderStyle = props.data.style.borderStyle;
      btn.current.style.borderRadius = props.data.style.borderRadius + "px";
      // document.getElementById(this.buttondata.myId.self).style.border = '1px solid ' + this.buttondata.style.borderColor;
    }
  }, [props.data]);

  useEffect(() => {
    console.log("buttonData", buttonData);
    if (buttonData) {
      let currentButton = buttonData.buttons.find((val) => {
        return val.buttonId == props.data.myId.self;
      });
      if (
        currentButton &&
        currentButton.click &&
        currentButton.click.length > 0
      ) {
        let foundObj = currentButton.click.find((val) => {
          return val.items.length > 0;
        });
        setButtonActions(foundObj.items);
        setButtonText(foundObj["displayString"]);
      }
    }
  }, [buttonData]);

  const iltAction = () => {
    if (buttonActions && Array.isArray(buttonActions)) {
      buttonActions.forEach((val, index) => {
        CheckActions(val, 'notSvg');
      });
    }
  };

  return (
    <>
      {props.data && (
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              display:
                props.initHide &&
                props.initHide.indexOf(props.data.myId.self) > -1
                  ? "none"
                  : "inline-block",
              textAlign: "center",
            }}
          >
            {buttonText &&
              buttonText.toLowerCase() != "play" &&
              buttonText.toLowerCase() != "play1" &&
              buttonText.toLowerCase() != "play2" &&
              buttonText.toLowerCase() != "info" &&
              buttonText.toLowerCase() != "close" &&
              buttonText.toLowerCase() != "play audio" &&
              !props.data.source && (
                <Button
                  variant={props.flat ? "text" : "contained"}
                  className={classes.flatbtn}
                  sx={{
                    ":hover": {
                      bgcolor:
                        props.data?.style?.background?.color &&
                        !props.data?.useOldStyle
                          ? props.data?.style?.background?.color
                          : "#DB8829",
                      boxShadow: "none",
                    },
                  }}
                  id={props.data.myId.self}
                  size=""
                  ref={btn}
                  onClick={iltAction}
                >
                  {buttonText}
                </Button>
              )}
            {props.data.source &&
              props.data.source.toLowerCase() != "play" &&
              props.data.source.toLowerCase() != "play1" &&
              props.data.source.toLowerCase() != "play2" &&
              props.data.source.toLowerCase() != "info" &&
              props.data.source.toLowerCase() != "close" &&
              props.data.source.toLowerCase() != "play audio" && (
                <Button
                  //variant={props.flat ? "text" : "contained"}
                  className={classes.flatbtn}
                  sx={{
                    // backgroundColor: props.data.style.background.color
                    //   ? props.data.style.background.color
                    //   : "#DB8829",
                    backgroundColor:
                      props.data?.style?.background?.color &&
                      !props.data?.useOldStyle
                        ? props.data?.style?.background?.color
                        : "#DB8829",
                    boxShadow: "none",
                    color: props.data.style.color
                      ? props.data.style.color
                      : "#FFFFFF",
                    fontSize: "1.1rem",
                    marginBottom: "0.2rem",
                    marginTop: "0.3rem",
                    py: 1.4,
                    borderRadius: 5,
                    boxShadow: "0px 0px 2px #CCCCCC",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.6rem",
                      mx: 0.5,
                      px: 3,
                    },
                    ":hover": {
                      bgcolor:
                        props.data?.style?.background?.color &&
                        !props.data?.useOldStyle
                          ? props.data?.style?.background?.color
                          : "#DB8829",
                      boxShadow: "none",
                    },
                  }}
                  id={props.data.myId.self}
                  size=""
                  ref={btn}
                  onClick={iltAction}
                  children={
                    <span
                      dangerouslySetInnerHTML={{
                        __html: unicodeToString(props.data.source),
                      }}
                    ></span>
                  }
                ></Button>
              )}
            {((!props.data.source &&
              buttonText &&
              (buttonText.toLowerCase() == "play" ||
                buttonText.toLowerCase() == "play1" ||
                buttonText.toLowerCase() == "play2" ||
                buttonText.toLowerCase() == "info" ||
                buttonText.toLowerCase() == "close" ||
                buttonText.toLowerCase() == "play audio")) ||
              (props.data.source &&
                (props.data.source.toLowerCase() == "play" ||
                  props.data.source.toLowerCase() == "play1" ||
                  props.data.source.toLowerCase() == "play2" ||
                  props.data.source.toLowerCase() == "info" ||
                  props.data.source.toLowerCase() == "close" ||
                  props.data.source.toLowerCase() == "play audio"))) && (
              <>
                <IconButton
                  aria-label="fingerprint"
                  //className={classes.roundbtn}
                  //sx={{ ":hover": { bgcolor: "#AB47BC", boxShadow: "none" } }}
                  id={props.data.myId.self}
                  onClick={iltAction}
                  ref={btn}
                  sx={{
                    backgroundColor: "#DB8829",
                    margin: "2px",
                    borderRadius: "50px !important",
                    ":hover": { bgcolor: "#DB8829", boxShadow: "none" },
                  }}
                >
                  {(props.data.source.toLowerCase() == "" ||
                    props.data.source.toLowerCase() == "play" ||
                    props.data.source.toLowerCase() == "play1" ||
                    props.data.source.toLowerCase() == "play2") && (
                    <VolumeUpIcon
                      sx={{
                        color: "#FFFFFF",
                        fontSize:
                          props.data.source.toLowerCase() == "play" ||
                          props.data.source.toLowerCase() == ""
                            ? "1.5rem"
                            : props.data.source.toLowerCase() == "play1"
                            ? "1.25rem"
                            : "1rem",
                        "@media (min-width: 1636px)": { fontSize: "2.2rem" },
                      }}
                    />
                  )}
                  {props.data.source.toLowerCase() == "info" && (
                    <NoteAddIcon
                      sx={{
                        color: "#FFFFFF",
                        fontSize: "1.5rem",
                        "@media (min-width: 1636px)": { fontSize: "2.2rem" },
                      }}
                    />
                  )}
                  {props.data.source.toLowerCase() == "close" && (
                    <HighlightOffIcon
                      sx={{
                        color: "#FFFFFF",
                        fontSize: "1.5rem",
                        "@media (min-width: 1636px)": { fontSize: "2.2rem" },
                      }}
                    />
                  )}
                </IconButton>
              </>
            )}
          </Grid>
        </Grid>
      )}
    </>
  );
};
const useStyles = makeStyles({
  flatbtn: {
    borderRadius: "2",
    fontWeight: "bold",
    boxShadow: "none",
    textTransform: "none",
  },
  roundbtn: {
    height: "3em !important",
    minWidth: "40px !important",
    maxWidth: "40px !important",
    border: "solid 0px red",
    borderRadius: "50%",
  },
});
export default WwILTButton;
